module.exports = __webpack_public_path__ + "static/media/PATS_5-1690w.f2712240.png";